module.exports = __webpack_public_path__ + "static/media/sb-close.7f088fc5.svg";